function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:enabled, [tabindex]:not([tabindex^=\'-\']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe',
    ),
  )
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true,
  )
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.focus()
}


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class HeroBannerCountdownTimer extends HTMLElement {
  constructor() {
    super()
    this.digitElements = Array.from(this.querySelectorAll('.digit'))
    this.startTime = Date.now()
    this.endTime = null
  }

  connectedCallback() {
    this.endTime = new Date(this.getAttribute('end-time').replace(' ', 'T'))
    this.startTimer()
    setTimeout(() => {
      this.style.display = 'block'
    }, 1000)
  }

  disconnectedCallback() {
  }

  setValues(values) {
    if (values.length !== this.digitElements.length) {
      console.error('Invalid values provided.')
      return
    }

    values.forEach((value, index) => {
      this.digitElements[index].textContent = value
    })
  }

  getTimeParts(delta) {
    const days = Math.floor(delta / 86400)
    delta -= days * 86400

    const hours = Math.floor(delta / 3600) % 24
    delta -= hours * 3600

    const minutes = Math.floor(delta / 60) % 60
    delta -= minutes * 60

    const seconds = Math.floor(delta % 60) // in theory the modulus is not required

    return [days, hours, minutes, seconds]
  }

  renderTimer(delta) {
    const timeParts = this.getTimeParts(delta)
    this.setValues(timeParts)
  }

  startTimer() {
    const intervalId = setInterval(() => {
      const delta = (this.endTime - Date.now()) / 1000
      if (delta >= 0) {
        this.renderTimer(delta)
      } else {
        clearInterval(intervalId)
        this.remove()
      }
    }, 1000)
  }
}

customElements.define('hero-banner-countdown-timer', HeroBannerCountdownTimer)

class BlogItem extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.tags = JSON.parse(this.dataset.tags)
  }

  disconnectedCallback() {
  }

  toggling(tag) {
    if (tag === 'all') {
      this.style.display = 'flex'
    } else {
      this.style.display = this.tags.includes(tag) ? 'flex' : 'none'
    }
  }
}

customElements.define('blog-item', BlogItem)

class BlogFilter extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.blogs = [...document.querySelectorAll('blog-item')]
    this.querySelector('select').addEventListener('change', this.handleFilterChange.bind(this))
  }

  disconnectedCallback() {
  }

  handleFilterChange(event) {
    this.blogs.forEach(blog => blog.toggling(event.target.value))
  }
}

customElements.define('blog-filter', BlogFilter)

class JudgemeStarOverride extends HTMLElement {
  constructor() {
    super()
    this.handleClick = this.handleClick.bind(this)
    this.addEventListener('click', this.handleClick)
  }

  connectedCallback() {
    const badge = this.querySelector('#judgeme-star-override-template .jdgm-prev-badge')
    if (!badge || Number(badge.dataset.numberOfReviews) === 0) {
      this.style.display = 'none'
      return
    }
    this.render({
      rating: Number(badge.dataset.averageRating).toFixed(1),
      reviewNumber: badge.dataset.numberOfReviews,
    })
  }

  handleClick() {
    const judgemeWidget = document.querySelector('.jdgm-widget')
    if (judgemeWidget) {
      judgemeWidget.scrollIntoView({ behavior: 'smooth' })
    }
  }

  render(data) {
    this.innerHTML = `
      <div>
        <span class="jdgm-prev-badge__stars">
          ${this.renderStars(Number(data.rating))}
          <span class="text-[14px] font-semibold">${data.rating}</span>
          <span class="text-[14px]">out of 5 based on <strong>${data.reviewNumber} review</strong></span>
        </span>
      </div>
    `
  }

  renderStars(rating) {
    return new Array(5)
      .fill('')
      .map((_, index) => {
        const starClass = rating >= index + 1 ? 'jdgm-star jdgm--on' : 'jdgm-star jdgm--half'
        return `<span class="${starClass}"></span>`
      })
      .join('')
  }
}
customElements.define('judgeme-star-override', JudgemeStarOverride)

class MattressComparisonTableJudgemeWidget extends JudgemeStarOverride {
  constructor() {
    super()
  }

  render(data) {
    this.innerHTML = `
      <div class="flex flex-col">
        <span class="jdgm-prev-badge__stars">
          ${this.renderStars(Number(data.rating))}
          <span class="text-[14px]">${data.rating}</span>
        </span>
        <span class="text-sm">(${data.reviewNumber} Reviews)</span>
      </div>
    `
  }
}

customElements.define('mattress-comparison-table-judgeme-widget', MattressComparisonTableJudgemeWidget);

class MattressComparisonTableExploreImageWidget extends HTMLElement {
  constructor() {
    super();
    this.exploreBtn = this.querySelector('button[data-explore-btn]');
    this.exploreBtn.addEventListener('click', this.handleClick.bind(this))
  }

  connectedCallback() {
    // Create popup structure when element is added to DOM
    this.popup = document.createElement('div');
    this.popup.className = 'hidden fixed top-0 left-0 w-full h-full bg-neutral-800 justify-center items-center';
    this.popup.style.setProperty('background-color', 'rgba(0, 0, 0, 0.8)');
    this.popup.style.setProperty('z-index', '99999');
    this.popup.innerHTML = `
      <div class="relative bg-white p-4 rounded-lg overflow-auto">
        <button class="close-btn">×</button>
        <img class="lazyload md:h-[70vh]" src="" alt="Enlarged image">
      </div>
    `;
    document.body.appendChild(this.popup);

    // Store references
    this.popupImg = this.popup.querySelector('img');
    this.closeBtn = this.popup.querySelector('.close-btn');
    this.originalImg = this.exploreBtn.getAttribute('data-image');

    // Add event listeners
    this.closeBtn.addEventListener('click', this.closePopup.bind(this));
    this.popup.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  handleClick() {
    console.log('abc');
    if (this.originalImg) {
      this.popupImg.src = this.originalImg;
      this.popup.style.display = 'flex';
    }
  }

  closePopup() {
    this.popup.style.display = 'none';
  }

  handleOutsideClick(e) {
    if (e.target === this.popup) {
      this.closePopup();
    }
  }

  disconnectedCallback() {
    if (this.popup) {
      document.body.removeChild(this.popup);
    }
  }
}

customElements.define('mattress-comparison-table-explore-image-widget', MattressComparisonTableExploreImageWidget);

class LogoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.querySelector('section.logo-carousel').id
    this.initLogoCarousel(sectionId)
  }

  renderAwardQuote(slide, sectionId) {
    if (slide.isClone) return
    const awardQuoteEl = $(slide.slide).data('quote')
    const awardQuote = $($.parseHTML(awardQuoteEl)).text()

    $(`#${sectionId} .award-quote`).text(awardQuote)
    const awardSubQuoteEl = $(slide.slide).data('sub-quote')
    const awardSubQuote = $($.parseHTML(awardSubQuoteEl)).text()

    $(`#${sectionId} .award-sub-quote`).text(awardSubQuote);
  }

  async initLogoCarousel(sectionId) {
    await ResourceCoordinator.requestVendor('Splide')

    const awardCarousel = new Splide(`#${sectionId} .splide`, {
      gap: '1.6rem',
      type: 'loop',
      perMove: 1,
      perPage: 5,
      pagination: false,
      arrows: true,
      focus: 'center',
      breakpoints: {
        768: {
          perPage: 3,
          pagination: true,
          arrows: false,
        },
      },
    })

    awardCarousel.on('active', (slide) => this.renderAwardQuote(slide, sectionId))

    setTimeout(() => {
      awardCarousel.mount()
    })
  }
}

customElements.define('logo-carousel', LogoCarousel);

class ComparisonChartPopupButton extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick)
  }

  handleClick() {
    const section = document.querySelector('[data-comparison-chart-popup]')
    const drawer = section.querySelector('[data-comparison-chart-popup--drawer]')
    drawer.style.display = 'block'

    setTimeout(() => {
      drawer.classList.add('show')
    }, 200);
  }
}

customElements.define('comparison-chart-popup-button', ComparisonChartPopupButton)

const discountSettings = [
  {
    schedules: [
      {
        startDate: '2024-04-29T00:01',
        endDate: '2024-05-12T23:59',
      },
    ],
    discountMap: [
      {
        name: 'Original Mattress 2.0 | Single - with free cloud pillow',
        prerequisiteVariantId: 43355823997122,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Original Mattress 2.0 | Double - with free cloud pillow',
        prerequisiteVariantId: 43355824029890,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Original Mattress 2.0 | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43355824062658,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Original Mattress 2.0 | Queen - with free cloud pillow',
        prerequisiteVariantId: 43355824095426,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Original Mattress 2.0 | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43355824128194,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Original Mattress 2.0 | King - with free cloud pillow',
        prerequisiteVariantId: 43355824160962,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Original Mattress 2.0 | King XL - with free cloud pillow',
        prerequisiteVariantId: 43355824193730,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Diamond Hybrid Mattress | Single - with free cloud pillow',
        prerequisiteVariantId: 42573038125250,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Diamond Hybrid Mattress | Double - with free cloud pillow',
        prerequisiteVariantId: 42746232012994,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Diamond Hybrid Mattress | Full Double - with free cloud pillow',
        prerequisiteVariantId: 42746459947202,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Diamond Hybrid Mattress | Queen - with free cloud pillow',
        prerequisiteVariantId: 42573038223554,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Diamond Hybrid Mattress | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 42852468850882,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Diamond Hybrid Mattress | King - with free cloud pillow',
        prerequisiteVariantId: 42573038256322,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Diamond Hybrid Mattress | King XL - with free cloud pillow',
        prerequisiteVariantId: 42852469244098,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1],
      },
      {
        name: 'Signature Bundle | Single - with free cloud pillow',
        prerequisiteVariantId: 43355827044546,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bundle | Double - with free cloud pillow',
        prerequisiteVariantId: 43355827077314,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bundle | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43355827110082,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bundle | Queen - with free cloud pillow',
        prerequisiteVariantId: 43355827142850,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bundle | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43355827175618,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bundle | King - with free cloud pillow',
        prerequisiteVariantId: 43355827208386,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bundle | King XL - with free cloud pillow',
        prerequisiteVariantId: 43355827241154,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Diamond Bundle | Single - with free cloud pillow',
        prerequisiteVariantId: 42675162284226,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Diamond Bundle | Double - with free cloud pillow',
        prerequisiteVariantId: 42848976044226,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Diamond Bundle | Full Double - with free cloud pillow',
        prerequisiteVariantId: 42848989151426,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Diamond Bundle | Queen - with free cloud pillow',
        prerequisiteVariantId: 42675162415298,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Diamond Bundle | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43196411969730,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Diamond Bundle | King - with free cloud pillow',
        prerequisiteVariantId: 42675162448066,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Diamond Bundle | King XL - with free cloud pillow',
        prerequisiteVariantId: 43196412199106,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Original 2.0) | Single - with free cloud pillow',
        prerequisiteVariantId: 43670223290562,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Original 2.0) | Double - with free cloud pillow',
        prerequisiteVariantId: 43670223323330,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Original 2.0) | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43670223356098,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Original 2.0) | Queen - with free cloud pillow',
        prerequisiteVariantId: 43670223388866,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Original 2.0) | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43670223421634,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Original 2.0) | King - with free cloud pillow',
        prerequisiteVariantId: 43670223454402,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Original 2.0) | King XL - with free cloud pillow',
        prerequisiteVariantId: 43670223487170,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Diamond Hybrid) | Single - with free cloud pillow',
        prerequisiteVariantId: 43670259761346,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Diamond Hybrid) | Double - with free cloud pillow',
        prerequisiteVariantId: 43670259794114,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Diamond Hybrid) | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43670259826882,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Diamond Hybrid) | Queen - with free cloud pillow',
        prerequisiteVariantId: 43670259859650,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Diamond Hybrid) | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43670259892418,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Diamond Hybrid) | King - with free cloud pillow',
        prerequisiteVariantId: 43670259925186,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Bundle (with Diamond Hybrid) | King XL - with free cloud pillow',
        prerequisiteVariantId: 43670259957954,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Original Mattress 2.0 | Single - with free cloud pillow',
        prerequisiteVariantId: 43790772666562,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Original Mattress 2.0 | Double - with free cloud pillow',
        prerequisiteVariantId: 43790772732098,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Original Mattress 2.0 | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43790772797634,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Original Mattress 2.0 | Queen - with free cloud pillow',
        prerequisiteVariantId: 43790772863170,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Original Mattress 2.0 | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43790772928706,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Original Mattress 2.0 | King - with free cloud pillow',
        prerequisiteVariantId: 43790772994242,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Original Mattress 2.0 | King XL - with free cloud pillow',
        prerequisiteVariantId: 43790773059778,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Diamond Mattress | Single - with free cloud pillow',
        prerequisiteVariantId: 43790772633794,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Diamond Mattress | Double - with free cloud pillow',
        prerequisiteVariantId: 43790772699330,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Diamond Mattress | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43790772764866,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Diamond Mattress | Queen - with free cloud pillow',
        prerequisiteVariantId: 43790772830402,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Diamond Mattress | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43790772895938,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Diamond Mattress | King - with free cloud pillow',
        prerequisiteVariantId: 43790772961474,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Signature Bed Only w/ Diamond Mattress | King XL - with free cloud pillow',
        prerequisiteVariantId: 43790773027010,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Original 2.0) | Single - with free cloud pillow',
        prerequisiteVariantId: 43790745469122,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Original 2.0) | Double - with free cloud pillow',
        prerequisiteVariantId: 43790745534658,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Original 2.0) | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43790745600194,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Original 2.0) | Queen - with free cloud pillow',
        prerequisiteVariantId: 43790745665730,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Original 2.0) | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43790745731266,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Original 2.0) | King - with free cloud pillow',
        prerequisiteVariantId: 43790745796802,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Original 2.0) | King XL - with free cloud pillow',
        prerequisiteVariantId: 43790745862338,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Diamond Hybrid) | Single - with free cloud pillow',
        prerequisiteVariantId: 43790745436354,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Diamond Hybrid) | Double - with free cloud pillow',
        prerequisiteVariantId: 43790745501890,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Diamond Hybrid) | Full Double - with free cloud pillow',
        prerequisiteVariantId: 43790745567426,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Diamond Hybrid) | Queen - with free cloud pillow',
        prerequisiteVariantId: 43790745632962,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Diamond Hybrid) | Queen XL - with free cloud pillow',
        prerequisiteVariantId: 43790745698498,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Diamond Hybrid) | King - with free cloud pillow',
        prerequisiteVariantId: 43790745764034,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
      {
        name: 'Wooden Bed Only (with Diamond Hybrid) | King XL - with free cloud pillow',
        prerequisiteVariantId: 43790745829570,
        discountEntitledVariantIds: [44172073828546],
        discountEntitledVariantQuantities: [1]
      },
    ],
  },
];



async function getCart() {
  return fetch("/cart.json").then((response) => response.json());
}

function getManilaTime() {
  const now = new Date();

  const options = {
    timeZone: 'Asia/Manila',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(now);

  const pad = (num, places) => String(num).padStart(places, '0');

  const year = parts.find(p => p.type === 'year').value;
  const month = pad(parts.find(p => p.type === 'month').value, 2);
  const day = pad(parts.find(p => p.type === 'day').value, 2);
  const hour = pad(parts.find(p => p.type === 'hour').value, 2);
  const minute = pad(parts.find(p => p.type === 'minute').value, 2);
  const second = pad(parts.find(p => p.type === 'second').value, 2);

  // Get microseconds manually
  const microseconds = pad(now.getUTCMilliseconds() * 1000, 6);

  // Manila is UTC+8
  const offset = '+08:00';

  return `${year}-${month}-${day}T${hour}:${minute}:${second}.${microseconds}${offset}`
}

async function updateCartGift({ sections, sectionUrl }) {
  const datetime = getManilaTime()
  const timeParts = datetime.split(':')
  const today = timeParts[0] + ':' + timeParts[1]

  let discountMaps = []
  discountSettings.forEach(setting => {
    if (setting.schedules.find(sch => sch.startDate <= today && sch.endDate >= today)) {
      discountMaps = discountMaps.concat(setting.discountMap)
    }
  })

  if (discountMaps.length === 0) {
    return { isGWP: false, state: null }
  }

  const cart = await getCart()
  const cartData = createCartData(cart)

  if (discountMaps && discountMaps.length) {
    if (cartData.isCartChanged) return { isGWP: true, state: await adjustAssociatedGift(cartData) }

    return { isGWP: false, state: cart }
  }

  if (cartData.giftExist) {
    return { isGWP: true, state: await removeGift(cartData) }
  }

  return { isGWP: false, state: cart }

  function createCartData(cart) {
    const result = {}
    result.items = cart.items.map(enhanceCartItem)
    result.GWPItems = result.items.filter(item => item.isGWP)
    result.nonGiftItems = result.items.filter(item => !item.properties?.isGift && !item.isGWP)
    result.giftItems = result.items
      .filter(item => item.properties?.isGift)

    result.giftExist = result.giftItems.length > 0

    adjustedGiftItems(result)

    result.items = result.GWPItems.concat(result.giftItems).concat(result.nonGiftItems)
    return result
  }

  function enhanceCartItem(item) {
    const result = { ...item }
    const discountMap = discountMaps.find(dm => dm.prerequisiteVariantId == result.variant_id)
    result.isGWP = !!discountMap
    result.associatedGift = result.isGWP ? discountMap.discountEntitledVariantIds : []
    result.associatedGiftQuantities = result.isGWP ? discountMap.discountEntitledVariantQuantities : []
    return result
  }

  function adjustedGiftItems(result) {
    let gifts = result.giftItems
    result.isCartChanged = false

    if (result.giftItems.length > result.GWPItems.length) {
      const associatedGiftIds = result.GWPItems.reduce((ids, gwpItem) => [...ids, ...gwpItem.associatedGift], [])
      const uniqueGiftIds = [...new Set(associatedGiftIds)]
      result.isCartChanged = uniqueGiftIds.length !== result.giftItems.length
    }

    if (result.GWPItems.length) {
      result.GWPItems.forEach(gwpItem => {
        const giftIds = gwpItem.associatedGift
        const giftQuantities = gwpItem.associatedGiftQuantities
        for (const [index, giftId] of giftIds.entries()) {
          const giftQuantity = giftQuantities[index]
          const giftIndex = gifts.findIndex(giftItem => giftItem.variant_id === giftId)
          const GWPs = result.GWPItems.filter(gwp => gwp.associatedGift.includes(giftId))
          const totalGiftAmount = GWPs.reduce((total, gwp) => {
            const subIndex = gwp.associatedGift.findIndex(discountEntitledVariantId => discountEntitledVariantId === giftId)
            return total + gwp.quantity * gwp.associatedGiftQuantities[subIndex]
          }, 0)
          if (giftIndex > -1) {
            if (gifts[giftIndex].quantity != totalGiftAmount) {
              gifts[giftIndex].quantity = totalGiftAmount
              result.isCartChanged = true
            }
            gifts[giftIndex].checked = true
          } else {
            gifts.push({
              variant_id: giftId,
              quantity: totalGiftAmount,
              properties: { isGift: true },
              checked: true,
            })
            result.isCartChanged = true
          }
        }
      })
    } else if (gifts.length) {
      result.isCartChanged = true
    }
    result.giftItems = gifts
  }

  async function adjustAssociatedGift(cartData) {
    let newItems = []
    const updates = cartData.giftItems.reduce((items, giftItem) => {
      // edge case when decreasing gwp item
      // shopify will add additional gift cart item with price > 0
      if (!giftItem.checked && giftItem.key) {
        return { ...items, [giftItem.key]: 0 }
      } else {
        const item = cart.items.find(item => item.key == giftItem.key)
        if (!item) {
          if (giftItem.key) {
            return { ...items, [giftItem.key]: 0 }
          } else {
            newItems.push(
              {
                id: giftItem.variant_id,
                quantity: giftItem.quantity,
                properties: { isGift: true },
              },
            )
            return items
          }
        }

        if (giftItem.quantity === item.quantity) {
          return items
        }
      }

      return { ...items, [giftItem.key]: giftItem.quantity }
    }, {})

    for (const item of newItems) {
      await requestCart(item, '/cart/add.js')
    }

    return await requestCart({ updates, sections, section_url: sectionUrl }, '/cart/update.js')
  }

  async function removeGift(cartData) {
    const updates = cartData.giftItems.reduce((items, giftItem) => ({
      ...items,
      [giftItem.key]: 0,
    }), {})
    return await requestCart({ updates: updates, sections, section_url: sectionUrl }, '/cart/update.js')
  }

  async function requestCart(payload = {}, url = '/cart/add.js') {
    try {
      const state = await fetch(`${url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
        body: JSON.stringify({ ...payload })
      });
      return await state.json();
    } catch (e) {
      return null;
    }
  }
}

class CartFlashSale extends CustomElement {
  props = {
    targetDate: '',
    cartProductHandles: '',
    triggerProductHandles: '',
  }

  constructor() {
    super()
  }

  get refs() {
    return {
      countdown: this.$el.find('[data-countdown-timer]'),
      day: this.$el.find('[data-day]'),
      hour: this.$el.find('[data-hour]'),
      minute: this.$el.find('[data-minute]'),
      second: this.$el.find('[data-second]'),
    }
  }

  beforeMount() {
    super.beforeMount();
  }

  mounted() {
    super.mounted()
    this.initSwiper();

    const { targetDate, triggerProductHandles, cartProductHandles } = this.props
    const startTime = Date.now()
    const endTime = new Date(targetDate.replace(' ', 'T'))

    let delta = (endTime - startTime) / 1000

    this.tick(delta)
    this.$el.find("button[data-atc]").click(this.onAddFlashSale)

    setInterval(() => {
      delta -= 1
      this.tick(delta)
    }, 1000)

    const triggerProducts = triggerProductHandles.split('|');
    const cartProducts = cartProductHandles.split('|');
    const isContaintTriggerProduct = triggerProducts.some(item => cartProducts.includes(item));

    if(isContaintTriggerProduct) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
  }

  async onAddFlashSale(e) {
    e.stopPropagation();
    const cartItems = document.getElementById('CartDrawerItems')
    const cartSummaryNode = document.getElementById('CartDrawerSummary');

    const $upsellItem = $(this).closest('cart-flash-sale-item')
    const $upsellVariantSelector = $upsellItem.find('.variant-selector select')

    const variantId = $upsellVariantSelector.find(":selected").val()

    const scrollableContentEl = $(this).closest('cart-scrollable-content').get(0);

    scrollableContentEl.loading = true
    cartSummaryNode.loading = true

    await cartItems.addToCart(variantId, 1, {});

    scrollableContentEl.loading = false
    cartSummaryNode.loading = false
  }


  tick(delta) {
    function pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    }

    const { day, hour, minute, second } = this.refs

    if (delta < 0) {
      this.$el.hide();
    }

    const timeParts = getTimeParts(delta)

    day.text(pad(timeParts[0], 2));
    hour.text(pad(timeParts[1], 2));
    minute.text(pad(timeParts[2], 2));
    second.text(pad(timeParts[3], 2));
  }

  async initSwiper() {
    const splide = this.querySelector('.splide')

    if (!splide) return

    await ResourceCoordinator.requestVendor('Splide')

    new Splide(splide, {
      perPage: 1,
      perMove: 1,
      gap: '20px',
      pagination: false,
      arrows: true,
      breakpoints: {
        768: {
          perPage: 1,
          arrows: false,
          pagination: true,
          gap: '8px',
        },
      },
    }).mount()
  }
}

customElements.define('cart-flash-sale', CartFlashSale);

class BlockFlashSale extends CartFlashSale {
  constructor() {
    super()
  }

  mounted() {
    super.mounted()
    const { targetDate } = this.props
    const startTime = Date.now()
    const endTime = new Date(targetDate.replace(' ', 'T'))

    let delta = (endTime - startTime) / 1000

    this.tick(delta)
    this.$el.find("button[data-atc]").click(this.onAddFlashSale)

    setInterval(() => {
      delta -= 1
      this.tick(delta)
    }, 1000)

    GlobalStore.subscribe((event) => {
      this.refreshBlock()
    })

    this.refreshBlock()
  }

  refreshBlock() {
    const { targetDate, triggerProductHandles } = this.props
    const startTime = Date.now()
    const endTime = new Date(targetDate.replace(' ', 'T'))
    const delta = endTime - startTime

    const cart = GlobalStore.getState().currentCart
    const triggerProducts = triggerProductHandles.split('|');
    const cartProducts = cart.items.map(item => item.handle);
    const isContaintTriggerProduct = triggerProducts.some(item => cartProducts.includes(item));

    if(delta <= 0) {
      this.$el.hide();
    } else {
      this.$el.show();
    }
  }

}

customElements.define('block-flash-sale', BlockFlashSale);

class ProductCatalogFlashSale extends CartFlashSale {
  constructor() {
    super()
  }

  mounted() {
    super.mounted()
    const { targetDate } = this.props
    const startTime = Date.now()
    const endTime = new Date(targetDate.replace(' ', 'T'))

    let delta = (endTime - startTime) / 1000

    this.tick(delta)
    this.$el.find("button[data-atc]").click(this.onAddFlashSale)

    setInterval(() => {
      delta -= 1
      this.tick(delta)
    }, 1000)

    this.refreshBlock()
  }

  refreshBlock() {
    const { targetDate } = this.props
    const startTime = Date.now()
    const endTime = new Date(targetDate.replace(' ', 'T'))
    const delta = endTime - startTime

    if(delta <= 0) {
      this.$el.hide();
    } else {
      this.$el.show();
    }
  }

}

customElements.define('product-catalog-flash-sale', ProductCatalogFlashSale);

class CartFlashSaleItem extends CustomElement {
  props = {
    saleValue: 0
  }

  beforeMount() {
    super.beforeMount();
    const variantSelector = this.querySelector('variant-selector')
    if (variantSelector) variantSelector.addEventListener('change', this.refreshPrice.bind(this));
  }

  get refs() {
    return {
      originalPrice: this.$el.find('[data-original-price]'),
      salePrice: this.$el.find('[data-sale-price]'),
    }
  }

  refreshPrice() {
    const $selectedOption = this.$el.find(':selected');
    const { salePrice: salePriceElm, originalPrice: originalPriceElm } = this.refs;

    const price = $selectedOption.data('price')
    const priceInCurrency = currencyFormatter.format(price);
    const salePrice = price * (100 - this.props.saleValue) / 100;
    const salePriceInCurrency = currencyFormatter.format(salePrice);

    salePriceElm.text(salePriceInCurrency);
    originalPriceElm.text(priceInCurrency);
  }
}

customElements.define('cart-flash-sale-item', CartFlashSaleItem);

document.addEventListener('DOMContentLoaded', function() {
  window.lozad('.lazyload').observe()

  if (location.pathname.includes('/policies')) {
    const policyContainer = document.querySelector('.shopify-policy__container')
    policyContainer.classList.add('prose', 'py-7')
  }

  const manilaDate = new Date(getManilaTime().split('.')[0])
  const bpiPromotionEndDate = new Date('2025-01-01T00:00:00')
  if (manilaDate > bpiPromotionEndDate) {
    document.querySelectorAll('.bpi-card').forEach(node => node.remove())
  }
})
